import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React from 'react';
import { TabPanels as ReachTabPanels } from '@reach/tabs';
var TabPanels = /*#__PURE__*/React.forwardRef(function TabPanels(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(ReachTabPanels, _extends({
    ref: ref
  }, rest), React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, {
      index
    });
  }));
});
export default TabPanels;